import {Coupon} from "./Coupon";
import {Task} from "./Task";
import {DiscountUtil} from "./../util/DiscountUtil";
import {Step} from "./Step";
import {Campaign} from "./Campaign";
import {Topic} from "./Topic";
import {Url} from "./Url";
import {FieldOption} from "./FieldOption";
import {Client} from "./Client";
import {Origin} from "./Origin";
import {Note} from "./Note";
import {User} from "./User";

export class Deal {
    constructor({
                    //attributes
                    id= null,
                    step_id= null,
                    user_id= null,
                    company_id= null,
                    type= 'unique_value',
                    automation_lists= [],
                    external_ref= '',
                    value= 0,
                    commission= 0,
                    profitMargin= 0,
                    visible_number= 10000,
                    demand_id= 0,
                    campaign_id= 0,
                    topic_id= 0,
                    status= 'sent',
                    discount_type= 'percent',
                    discount= 0,
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    opportunity_created_at= null,
                    conversion_date=null,
                    cancel_date=null,
                    closing_date= null,
                    shipping_fare= 0,
                    task_status= '',
                    sale_potential= 'mid',
                    utms=[],
                    extradata= {},
                    manufacturers_value= null,
                    delivery_date_internal= null,
                    //relations
                    coupon=null,
                    client=null,
                    client_id=null,
                    user= null,
                    collaborators= [],
                    quotation=null,
                    architect= null,
                    order=null,
                    purchaseOrders= [],
                    tasks= [],
                    step=null,
                    labels= [],
                    notes= [],
                    demand=null,
                    origin=null,
                    origin_id=null,
                    campaign=null,
                    topic=null,
                    url_id=null,
                    url=null,
                    fieldOptions=[],
                    expire_at=null,
                    loss_reason=null,
                    abandoned=null,
                    validityStatus = null,
                    final_value=0,
                    finalValueWithShipping=0,
                    touchpoints=[],
                    is_ecommerce=null,
                    is_estore=null,
                    need_followup=null,
                    value_negotiation=null
                } = {}) {

        //fill attributes
        this.value_negotiation=value_negotiation;
        this.need_followup=need_followup;
        this.is_ecommerce=is_ecommerce;
        this.is_estore = is_estore;
        this.touchpoints=touchpoints;
        this.final_value = final_value;
        this.automation_lists= automation_lists;
        this.finalValueWithShipping=finalValueWithShipping;
        this.utms = utms;
        this.abandoned = abandoned;
        this.id=id;
        this.step_id=step_id;
        this.company_id=company_id;
        this.type=type;
        this.external_ref=external_ref;
        this.value=value;
        this.commission=commission;
        this.profitMargin=profitMargin;
        this.visible_number=visible_number;
        this.demand_id=demand_id;
        this.campaign_id=campaign_id;
        this.topic_id=topic_id;
        this.status=status;
        this.discount_type=discount_type?discount_type:'percent';
        this.discount=discount;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;
        this.opportunity_created_at=opportunity_created_at;
        this.closing_date=closing_date;
        this.expire_at=expire_at;
        this.conversion_date=conversion_date;
        this.cancel_date=cancel_date;
        this.shipping_fare=shipping_fare;
        this.user_id=user_id;
        this.collaborators_ids=(collaborators|| []).map(u=>u.id);
        this.client_id=client_id;
        this.campaign_id=campaign_id;
        this.topic_id=topic_id;
        this.url_id=url_id;
        this.task_status=task_status;
        this.sale_potential=sale_potential;
        this.extradata=extradata;
        this.manufacturers_value=manufacturers_value;
        this.delivery_date_internal=delivery_date_internal;

        this.quotation=quotation;
        this.client=new Client(client || {});
        this.architect=new Client(architect || {});
        this.order=order;
        this.purchaseOrders=purchaseOrders;
        this.labels=labels;
        this.demand=demand;
        this.origin_id=origin_id;
        this.loss_reason=loss_reason;
        this.validityStatus=validityStatus;

        this.user= new User(user || {});
        this.collaborators= (collaborators || []).map(u=>new User(u));
        this.notes=(notes||[]).map(n=>new Note(n));
        this.internal_origin=new Origin(origin||{});
        this.step=new Step(step||{});
        this.coupon = new Coupon(coupon || {});
        this.step = new Step(step || {});
        this.campaign = new Campaign(campaign||{});
        this.topic = new Topic(topic||{});
        this.url = new Url(url||{});
        this.tasks = tasks.map(task=>new Task(task));
        this.fieldOptions = (fieldOptions||[]).map(f=>new FieldOption(f));

    }

    get finalValue(){


        return this.final_value;
    }

    get origin(){
        return this.internal_origin
    }

    set origin(value){
        this.internal_origin=value
        if(value)
            this.origin_id = value.id
    }

    hasClient(){
        return !!this.client;
    }

    get fieldsNameValuePair(){
        return this.fieldOptions.reduce((pairs, f)=>{
            pairs[f.field.label]=f.value;
            return pairs
        }, {});
    }
}

export function createDeal(data={}) {
    return Object.freeze(new Deal(data));
}
